import { render, staticRenderFns } from "./SurveyPage.vue?vue&type=template&id=2fae38b5&scoped=true"
import script from "./SurveyPage.vue?vue&type=script&lang=js"
export * from "./SurveyPage.vue?vue&type=script&lang=js"
import style0 from "./SurveyPage.vue?vue&type=style&index=0&id=2fae38b5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae38b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fae38b5')) {
      api.createRecord('2fae38b5', component.options)
    } else {
      api.reload('2fae38b5', component.options)
    }
    module.hot.accept("./SurveyPage.vue?vue&type=template&id=2fae38b5&scoped=true", function () {
      api.rerender('2fae38b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/survey-builder/components/SurveyPage.vue"
export default component.exports